export const primeln = {
    de: {
        firstDayOfWeek: 0,
        dayNames: [
            "Sonntag",
            "Montag",
            "Dienstag",
            "Mittwoch",
            "Donnerstag",
            "Freitag",
            "Samstag"
        ],
        dayNamesShort: ["So","Mo","Di","Mi","Do","Fr","Sa"],
        dayNamesMin: ["So","Mo","Di","Mi","Do","Fr","Sa"],
        monthNames: [
            "Januar",
            "Februar",
            "März",
            "April",
            "Mai",
            "Juni",
            "Juli",
            "August",
            "September",
            "Oktober",
            "November",
            "Dezember"
        ],
        monthNamesShort: [
            "Jan",
            "Feb",
            "Mär",
            "Apr",
            "Mai",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Okt",
            "Nov",
            "Dez"
        ],
        today: "Heute",
        clear: "Reset",
        // addLocale() shallow-merges this object over PrimeReact's English "aria" defaults (see
        // primereact/api), so every key must be repeated here — an object with only `close` would
        // wipe out the other aria.* strings for this locale instead of leaving them in English.
        aria: {
            cancelEdit: "Cancel Edit",
            close: "Schließen",
            collapseLabel: "Collapse",
            collapseRow: "Row Collapsed",
            editRow: "Edit Row",
            expandLabel: "Expand",
            expandRow: "Row Expanded",
            falseLabel: "False",
            filterConstraint: "Filter Constraint",
            filterOperator: "Filter Operator",
            firstPageLabel: "First Page",
            gridView: "Grid View",
            hideFilterMenu: "Hide Filter Menu",
            jumpToPageDropdownLabel: "Jump to Page Dropdown",
            jumpToPageInputLabel: "Jump to Page Input",
            lastPageLabel: "Last Page",
            listLabel: "Option List",
            listView: "List View",
            moveAllToSource: "Move All to Source",
            moveAllToTarget: "Move All to Target",
            moveBottom: "Move Bottom",
            moveDown: "Move Down",
            moveToSource: "Move to Source",
            moveToTarget: "Move to Target",
            moveTop: "Move Top",
            moveUp: "Move Up",
            navigation: "Navigation",
            next: "Next",
            nextPageLabel: "Next Page",
            nullLabel: "Not Selected",
            otpLabel: "Please enter one time password character {0}",
            pageLabel: "Page {page}",
            passwordHide: "Hide Password",
            passwordShow: "Show Password",
            previous: "Previous",
            prevPageLabel: "Previous Page",
            removeLabel: "Remove",
            rotateLeft: "Rotate Left",
            rotateRight: "Rotate Right",
            rowsPerPageLabel: "Rows per page",
            saveEdit: "Save Edit",
            scrollTop: "Scroll Top",
            selectAll: "All items selected",
            selectLabel: "Select",
            selectRow: "Row Selected",
            showFilterMenu: "Show Filter Menu",
            slide: "Slide",
            slideNumber: "{slideNumber}",
            star: "1 star",
            stars: "{star} stars",
            trueLabel: "True",
            unselectAll: "All items unselected",
            unselectLabel: "Unselect",
            unselectRow: "Row Unselected",
            zoomImage: "Zoom Image",
            zoomIn: "Zoom In",
            zoomOut: "Zoom Out"
        }
    },
    fr: {
        firstDayOfWeek: 1,
        dayNames: [
            "Dimanche",
            "Lundi",
            "Mardi",
            "Mercredi",
            "Jeudi",
            "Vendredi",
            "Samedi"
        ],
        dayNamesShort: ["dim", "lun", "mar", "mer", "jee", "ven", "sam"],
        dayNamesMin: ["D", "L", "M", "Me", "J", "V", "S"],
        monthNames: [
            "Janvier",
            "Février",
            "Mars",
            "Avril",
            "Mai",
            "Juin",
            "Juillet",
            "Août",
            "Septembre",
            "Octobre",
            "Novembre",
            "Décembre"
        ],
        monthNamesShort: [
            "jan",
            "fev",
            "mar",
            "avr",
            "mai",
            "jun",
            "jul",
            "aou",
            "sep",
            "oct",
            "nov",
            "dec"
        ],
        today: "Aujourd'hui",
        clear: "Réinitialiser ",
        // See the German locale above for why every aria.* key must be repeated here.
        aria: {
            cancelEdit: "Cancel Edit",
            close: "Fermer",
            collapseLabel: "Collapse",
            collapseRow: "Row Collapsed",
            editRow: "Edit Row",
            expandLabel: "Expand",
            expandRow: "Row Expanded",
            falseLabel: "False",
            filterConstraint: "Filter Constraint",
            filterOperator: "Filter Operator",
            firstPageLabel: "First Page",
            gridView: "Grid View",
            hideFilterMenu: "Hide Filter Menu",
            jumpToPageDropdownLabel: "Jump to Page Dropdown",
            jumpToPageInputLabel: "Jump to Page Input",
            lastPageLabel: "Last Page",
            listLabel: "Option List",
            listView: "List View",
            moveAllToSource: "Move All to Source",
            moveAllToTarget: "Move All to Target",
            moveBottom: "Move Bottom",
            moveDown: "Move Down",
            moveToSource: "Move to Source",
            moveToTarget: "Move to Target",
            moveTop: "Move Top",
            moveUp: "Move Up",
            navigation: "Navigation",
            next: "Next",
            nextPageLabel: "Next Page",
            nullLabel: "Not Selected",
            otpLabel: "Please enter one time password character {0}",
            pageLabel: "Page {page}",
            passwordHide: "Hide Password",
            passwordShow: "Show Password",
            previous: "Previous",
            prevPageLabel: "Previous Page",
            removeLabel: "Remove",
            rotateLeft: "Rotate Left",
            rotateRight: "Rotate Right",
            rowsPerPageLabel: "Rows per page",
            saveEdit: "Save Edit",
            scrollTop: "Scroll Top",
            selectAll: "All items selected",
            selectLabel: "Select",
            selectRow: "Row Selected",
            showFilterMenu: "Show Filter Menu",
            slide: "Slide",
            slideNumber: "{slideNumber}",
            star: "1 star",
            stars: "{star} stars",
            trueLabel: "True",
            unselectAll: "All items unselected",
            unselectLabel: "Unselect",
            unselectRow: "Row Unselected",
            zoomImage: "Zoom Image",
            zoomIn: "Zoom In",
            zoomOut: "Zoom Out"
        }
    }
};
